import React, { PureComponent } from 'react';

import { Button } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import SubtitleCard from './SubtitleCard';

export default class SubtitleTranslateBanner extends PureComponent {
  static propTypes = {
    onTranslate: PropTypes.func,
    subtitleId: PropTypes.string
  };

  render() {
    return (
      <SubtitleCard className="subtitle__translate__banner" small>
        <SubtitleCard.Header label="player_subtitles.type_description.TRANSLATION" />

        <SubtitleCard.Content>
          <p className="subtitle__translate__description">
            <I18n label="player_subtitles.translate.banner_description" />
          </p>

          <Button size="medium" outline onClick={this.onClick}>
            <I18n label="player_subtitles.translate.label" />
          </Button>
        </SubtitleCard.Content>
      </SubtitleCard>
    );
  }

  onClick = () => {
    const { onTranslate, subtitleId } = this.props;

    onTranslate && onTranslate(subtitleId);
  };
}
